module.exports = __webpack_public_path__ + "static/media/cv_2.c62851f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/cv_2.png
// module id = 614
// module chunks = 0